import axios from 'axios'

const { REACT_APP_EOS_URL: EOS_URL } = process.env
export const getClientApps = (pageIndex = 0, pageSize = 100) => {
    const url = new URL('/api/clientapp', EOS_URL)
    url.searchParams.set('pageIndex', pageIndex.toString())
    url.searchParams.set('pageSize', pageSize.toString())
    return axios.get(url.toString())
}